<template>
  <div class="enroll-exam-write-score-update">
    <el-popover
      @keydown.enter.native="updateScore"
      placement="top"
      width="180"
      v-model="visible">
      <el-form ref="form" label-width="70px">
        <el-form-item label="成绩：">
          <el-input v-model="score" size="mini" type="number" min="0"
                    @keydown.enter.native="updateScore" @keydown.esc.native="visible = false"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" @click="visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click="updateScore" :loading="loading">确定</el-button>
      </div>
      <span slot="reference" class="data">{{$attrs['cell-value']}}
        <span class="icon"><i class="el-icon-edit"></i></span>
      </span>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'EnrollExamWriteScoreUpdate',
  data () {
    return {
      visible: false,
      score: null,
      loading: false
    }
  },
  created () {
    this.score = this.$attrs['cell-value']
  },
  activated () {
    this.score = this.$attrs['cell-value']
  },
  methods: {
    updateScore () {
      if (this.score) {
        const r = /^([1-9]?\d{0,2}(\.\d{1,2})?)$/
        if (!r.test(this.score)) {
          this.$message.warning('请输入0-200内的分值，最大两位小数')
          return false
        }
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/exam/write/score/update/score',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.$attrs['row-data'].id,
          score: this.score,
          examSubjectId: this.$attrs['cell-param']
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('reloadGridData')
              break
            }
            default: {
              this.$message.error(response.data['message'] || '修改失败')
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.enroll-exam-write-score-update {
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;
  .data{
    .icon{
      margin-left: 5px;
    }
  }
}
</style>
